/**
 * nextStepUtils.js
 *
 * Utility functions for determining the next step in the onboarding wizard.
 */

/**
 * Determines the next step in the wizard based on the selected intents.
 *
 * @param {object} data - The collected onboarding data.
 * @returns {string} The ID of the next step.
 */
export function intentNext(data) {
  const intents = data.selectedIntents ?? [];

  const has = (...vals) => vals.every(v => intents.includes(v));

  // educator
  if (has('school_educator')) return "educator_subjects"

  // partner
  if (has('community_partner')) return "partner_expertise"

  // no role or 'org_educator'
  if (intents.length === 0) return "zipcode"
  return "zipcode"
}

/**
 * Determines the next step in the wizard based on the selected intents.
 *
 * @param {object} data - The collected onboarding data.
 * @returns {string|null} The ID of the next step.
 */
export function zipCodeNext(data) {
  const intents = data.selectedIntents ?? [];

  const has = (...vals) => vals.every(v => intents.includes(v));

  // educator
  if (has('school_educator')) return "site"

  return null
}

/**
 * Determines the next step after selecting educator subjects.
 *
 * @param {object} data - The collected onboarding data.
 * @returns {string} The ID of the next step.
 */
export function educatorSubjectsNext(data) {
  const intents = data.selectedIntents ?? [];

  const has = (...vals) => vals.every(v => intents.includes(v));

  // partner
  if (has('community_partner')) return "partner_expertise"

  return "zipcode"
}
